export default {
  GET_FAQS: state => {
    return state.faqs
  },
  GET_ANSWERS: state => {
    return state.answers
  },
  GET_ALERTS: state => {
    return state.alerts
  },
}
